import { render, staticRenderFns } from "./AcervosServentia.vue?vue&type=template&id=3519efb8&"
import script from "./AcervosServentia.vue?vue&type=script&lang=js&"
export * from "./AcervosServentia.vue?vue&type=script&lang=js&"
import style0 from "./AcervosServentia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports